import React, { useState, useContext, useEffect } from 'react'
import { motion } from 'framer-motion'
import api from '../../services/api';
import Barcode from 'react-barcode';
import TextArea from '../TextArea';
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import app from '../../firebase/config';
import Button from 'react-bootstrap/Button';
import Input from '../Input'
import Select from '../Select';
import { MarkContext } from '../../context/mark'
import { ProductsContext } from '../../context/products'
import { CategorysContext } from '../../context/categorys'
import { ToastContainer, toast } from 'react-toastify';
import deletIcon from '../../images/png/deleteIcon.png'
import Lottie from 'react-lottie';
import animation from '../../images/animated/Animation - 1736909631947.json'
import ReactLoading from 'react-loading';

const CardInput = styled.section`

    display: flex;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 0.9em;


    input,select{
        width: 100%;
        height: 50px;
        border-radius: 10px;
    }

    div > label{
        font-size: 0.9rem;
    }

    .textPrimary{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        margin-bottom: 0rem;
        font-size: 1.2rem;
    }

    div{
        margin-left:1.5rem;
    }

    @media screen and (max-width:720px){
        flex-direction: column;
        div{
            margin-left: 0rem;
        }

    }


`
const CardWrapper = styled.section`
    display: flex;
    flex-direction: column;


`
const CardBarCode = styled.div`

    display: flex;
    justify-content: center;
    align-items: center;

`
const ContainerTextArea = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 0.9rem;

`
const CardTextArea = styled.div`
    width: 85%;
    margin: 0 auto;

`
const CardImagesPreview = styled.div`

    padding:1.4rem;
    display: flex;
    width: 90%;
    overflow-x: auto;

`
const CardImage = styled.div`
    position: relative;
    .delete_icon{
        object-fit: contain;
        cursor: pointer;
        position: absolute;
        top: -28%;
        left: 0;
        width: 19px;
        height:19px;
    }


`
const ImagePreview = styled.img`
    margin-top: 1.1rem;
    object-fit: contain;
    width: 60px;
    height: 60px;
    border-radius: 100px;
    margin-right: 0.9rem;
    box-shadow: 0 0 5px black;

`
const CardDataSheet = styled.div`
    padding: 1.5rem;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 70%;
    height: 70%;
    margin: 0 auto;
    border: 1px solid #dddddd;
    border-radius: 5px;
    margin-bottom: 1.2rem;


`
const InputDataSheet = styled.input`
    font-family: "Poppins";
    font-weight: 500;
    appearance: none;
    font-size: 1rem;
    color: black;
    padding-left: 0.4rem;
    width: 420px;
    margin-bottom: 0.9rem;
    height: 45px;
    border:1px solid rgb(215, 215, 215);
    outline:none;
    border-radius: 5px;

    @media screen and (max-width:720px){
        width: 97%;
    }


`
const ContainerCardDataSheet = styled.div`

    p{
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 100px;
        width: 20px;
        height: 20px;
        color: white;
        right: 80%;
        top: -5%;

        position: absolute;
        background-color: black;
    }

    position: relative;

    .delete_icon_datasheet{
        background: white;
        cursor: pointer;
        top: -5%;
        left: 80%;
        position: absolute;
        width: 19px;
        height: 19px;
        object-fit: contain;
    }


`
const CardProductPreview = styled.div`
    position:relative;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
    height: 160px;
    border: 1px solid #c4c1c1dd;
    box-shadow: 0 0 5px #c4c1c196;
    border-radius: 100px;
`
const ImageProductPreview = styled.img`
    object-fit: cover;
    width: 112px;
    background-color: transparent;
    height: 112px;
    margin: 0 auto;

    @media screen and (max-width:820px){
        margin-bottom: 1.5rem;
    }

`
const ButtonChangeImage = styled.button`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    bottom: 0;
    background-color: black;
    width: 40px;
    height: 40px;
    border-radius: 100px;

    label{
        display:flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        margin: 0 auto;
    }

`

const ModalEditProduct = ({ props }) => {

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }

    const { marks } = useContext(MarkContext)
    const { storageProduct, editProductData, update, getProducts, idEditProduct, setBtnAnimation, btnAnimation,setProducts } = useContext(ProductsContext)
    const { categorys, subCategorys } = useContext(CategorysContext)

    const [imagesFirebase, setImagesFirebase] = useState([])
    const [selectTypeStock, setSelectTypeStock] = useState()
    const [barCodePreview, setBarCodePreview] = useState()

    const [name, setName] = useState()
    const [typeProductEdit, setTypeProductEdit] = useState()
    const [markProduct, setMarkProduct] = useState()
    const [typeStockProduct, setTypeStockProduct] = useState()
    const [qtdStock, setQtdStock] = useState()
    const [categoryProduct, setCategoryProduct] = useState()
    const [subCategoryProduct, setSubCategoryProduct] = useState()
    const [sessionProduct, setSessionProduct] = useState()
    const [freeShippingProduct, setFreeShippingProduct] = useState()
    const [description, setDescription] = useState()
    const [sku, setSku] = useState()
    const [barCodeEdit, setBarCodeEdit] = useState()
    const [weight, setWeight] = useState()
    const [lenght, setLenght] = useState()
    const [width, setWidth] = useState()
    const [height, setHeight] = useState()
    const [price, setPrice] = useState()
    const [promotionPrice, setPromotionalPrice] = useState()
    const [productImage, setProductImage] = useState()
    const [removeImage, setRemoveImage] = useState(false)
    const [imagePreview, setImagePreview] = useState()
    const [imagesPreview, setImagesPreview] = useState([])
    const [dataSheet, setDatasheet] = useState([])
    const [productImages, setProductImages] = useState([])



    const [typeProduct] = useState([
        {
            value: "Físico"
        },
        {
            value: "Digital"
        },

    ])
    const [typeStock] = useState([
        {
            value: "Sob Encomenda"
        },
        {
            value: "Pronta Entrega"
        },

    ])
    const [typeSession] = useState([

        {
            "name": "Produtos em destaque",
        },
        {
            "name": "Engates Com Rabicho Fixo",
        },
        {
            "name": "Engates Com Rabicho Removível",
        },
        {
            "name": "Acessórios para carretinha",
        },


    ])
    const [freeShipping] = useState([
        {
            name: "Sim"
        },
        {
            name: "Não"
        }
    ])

    const handleImage = (file) => {

        if (file) {

            const { type } = file

            const supportedTypes = ["image/png", "image/jpg", "image/jpeg"]
            const verifySupportedType = supportedTypes.includes(type)


            if (!verifySupportedType) {
                return toast.error("Formato de imagem não suportado!")
            }

            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = async () => {

                setImagesPreview([...imagesPreview, reader.result])
                setImagesFirebase([...imagesFirebase, file])
                // console.log(imagesFirebase)
            }

        }

    }
    const handleRemoveImage = async (index, id) => {
        const updateImages = [...imagesPreview]
        const updateImagesFirebase = [...imagesFirebase]
        updateImages.splice(index, 1)
        updateImagesFirebase.splice(index, 1)
        setImagesPreview(updateImages)
        const response = await api.delete(`panel/product/image/${id}`)
        getProductImages(id)
        setBtnAnimation(false)



    }
    const handleRemoveImageDatabase = async (index, id) => {
        const response = await api.delete(`panel/product/image/${id}`)
        setRemoveImage(!removeImage)
        setBtnAnimation(false)

    }
    const handleUpdateDataSheet = async (index, name_input, value) => {

        dataSheet[index][name_input] = value
        setDatasheet([...dataSheet])

    }
    const handleNewDataSheet = async () => {
        const newDataSheet =
        {
            name: "",
            value: ""
        }
        setDatasheet([...dataSheet, newDataSheet])
    }
    const handleRemoveDataSheet = (index) => {

        const update = [...dataSheet]
        update.splice(index, 1)
        setDatasheet(update)

    }
    const getProductImages = async (id) => {
        const response = await api.get(`/panel/product/images/${id}`)
        if (response.status == 200) {
            setProductImages(response.data)
            return false
        }

        if (response.status == 404) {
            setProductImages([])
        }

    }
    const handleDatabaseImage = async () => {
        if (imagesFirebase.length > 0) {
            setBtnAnimation(true)
            // Faz uma chamada para obter o índice atual das imagens
            const response = await api.get(`panel/get/index/product/${idEditProduct}`);
            // Criar um conjunto com os nomes das imagens existentes para evitar duplicatas
            const existingImageNames = new Set(imagesFirebase.map(img => img.file_name));

            // Filtrar novas imagens que ainda não estão no banco de dados
            const newImages = imagesFirebase.filter(file => !existingImageNames.has(file.name));

            // Verifica se há novas imagens para enviar
            if (newImages.length === 0) {
                console.log("Nenhuma nova imagem para enviar.");
                return;
            }

            // Calcular o índice baseado no último índice conhecido
            const existingCount = Number(response.data[0].index) + 1;

            // Criar uma lista de novas imagens com índices apropriados
            const imagesWithIndex = newImages.map((item, index) => ({
                item,
                index: existingCount + index // Define os índices começando a partir do total existente
            }));

            const uploadPromises = imagesWithIndex.map(async ({ item, index }) => {
                try {
                    const storageRef = app.storage().ref(`/products/images/${item.name}`);
                    await storageRef.put(item);
                    const imageUrl = await storageRef.getDownloadURL();

                    // Envia a imagem para a API com o índice correto
                    await api.post("panel/storage/product/image", {
                        file_name: item.name,
                        image: imageUrl,
                        product_id: idEditProduct,
                        index: index // Usando o novo índice calculado
                    });

                    console.log(`Imagem ${index} enviada com sucesso: ${imageUrl}`);
                    return true; // Retorna true se o upload foi bem-sucedido
                } catch (error) {
                    console.error(`Erro ao enviar imagem ${index} (${item.name}):`, error);
                    return false; // Retorna false se houve erro
                }
            });

            try {
                // Aguarda o processamento de todas as promessas
                const results = await Promise.all(uploadPromises);

                if (results.every(result => result)) {
                    console.log("Todas as imagens foram carregadas com sucesso.");
                } else {
                    console.warn("Algumas imagens falharam ao carregar.");
                }
            } catch (error) {
                console.error("Erro ao processar uploads:", error);
            } finally {
                setBtnAnimation(false)
            }
        } else {
            console.log("Nenhuma imagem existente para contar. Começando com índice 0.");
        }
    }
    const handleUpdate = async (field, value, id) => {
        props.onHide()
        await handleDatabaseImage()
        props.onHide()

    }
    const handleCentralImage = (file) => {

        if (file) {

            const { type } = file

            const supportedTypes = ["image/png", "image/jpg", "image/jpeg"]
            const verifySupportedType = supportedTypes.includes(type)


            if (!verifySupportedType) {
                return toast.error("Formato de imagem não suportado!")
            }

            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = async () => {
                setImagePreview(reader.result)

                const loadingToastId = toast.loading("Processando imagem...");

                const storageRef = app.storage().ref(`/products/images/${file.name}`);
                await storageRef.put(file);
                const imageUrl = await storageRef.getDownloadURL();
                update("product_image", imageUrl)


                toast.update(loadingToastId, {
                    render: "Imagem alterada com sucesso!",
                    type: "success",
                    isLoading: false,
                    autoClose: 1000
                });

                // window.location.href="/dashboard/products"

            }

        }
    }



    useEffect(() => {
        getProductImages(editProductData?.product_id)
    }, [removeImage])


    useEffect(() => {
        setProductImage(editProductData?.product_image)
        getProductImages(editProductData?.product_id)
        setName(editProductData?.name)
        setMarkProduct(editProductData?.category)
        setTypeProductEdit(editProductData?.type_product)
        setTypeStockProduct(editProductData?.type_stock)
        setQtdStock(editProductData?.qtd_stock)
        setCategoryProduct(editProductData?.engateCategory)
        setSubCategoryProduct(editProductData?.sub_category)
        setSessionProduct(editProductData?.session_product)
        setFreeShippingProduct(editProductData?.free_shipping)
        setDescription(editProductData?.description)
        setSku(editProductData?.sku)
        setBarCodeEdit(editProductData?.barCode)
        setBarCodePreview(editProductData?.barCode)
        setWeight(editProductData?.weight)
        setLenght(editProductData?.length)
        setWidth(editProductData?.width)
        setHeight(editProductData?.height)
        if (editProductData?.datasheet) {
            const datasheetArray = editProductData?.datasheet;
            setDatasheet(datasheetArray);

        }

        setPrice(Number(editProductData?.price).toLocaleString('pt-BR', { minimumFractionDigits: 2 }))
        setPromotionalPrice(Number(editProductData?.promotion_price).toLocaleString('pt-BR', { minimumFractionDigits: 2 }))
        console.log(editProductData)
    }, [editProductData])



    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar Produto
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <CardWrapper>
                    <CardProductPreview>
                        {imagePreview

                            ?
                            <ImageProductPreview src={`data:image/;base64;${imagePreview}`} />

                            :
                            <ImageProductPreview src={productImage} />
                        }
                        <ButtonChangeImage >
                            <label htmlFor='central_image' style={{ zIndex: "999999px" }}>
                                <svg width="23" height="23" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.7496 4.46524C12.3248 4.46524 11.9348 4.22314 11.7398 3.84961L11.2384 2.84662C10.918 2.21716 10.0823 1.69837 9.37196 1.69837H7.77715C7.05984 1.69837 6.22413 2.21716 5.90377 2.84662L5.40235 3.84961C5.20735 4.22314 4.81735 4.46524 4.39254 4.46524C2.8813 4.46524 1.68345 5.73108 1.78095 7.22518L2.14309 12.9388C2.22666 14.3637 2.99969 15.5327 4.92182 15.5327H12.2203C14.1425 15.5327 14.9085 14.3637 14.9991 12.9388L15.3612 7.22518C15.4587 5.73108 14.2609 4.46524 12.7496 4.46524ZM7.52644 5.32988H9.61571C9.90124 5.32988 10.138 5.56506 10.138 5.84867C10.138 6.13227 9.90124 6.36745 9.61571 6.36745H7.52644C7.24091 6.36745 7.00412 6.13227 7.00412 5.84867C7.00412 5.56506 7.24091 5.32988 7.52644 5.32988ZM8.57108 12.8488C7.27573 12.8488 6.21716 11.8043 6.21716 10.5108C6.21716 9.21732 7.26876 8.17283 8.57108 8.17283C9.87339 8.17283 10.925 9.21732 10.925 10.5108C10.925 11.8043 9.86642 12.8488 8.57108 12.8488Z" fill="white" />
                                </svg>
                            </label>

                            <input type='file' name='central_image' id="central_image" onChange={(e) => handleCentralImage(e.target.files[0])} style={{ display: "none" }} />


                        </ButtonChangeImage>
                    </CardProductPreview>

                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Informações iniciais</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"Nome *"} onChange={(e) => setName(e.target.value)} value={name} onBlur={(e) => update("name", e.target.value)} />
                        <Select name={"Tipo de produto *"} editValue={typeProductEdit} onBlur={(e) => update("type_product", e.target.value)} onChange={(e) => setTypeProductEdit(e.target.value)} target={"value"} data={typeProduct} />
                    </CardInput>

                    <CardInput>
                        <Select name={"Marca do produto *"} editValue={markProduct} onBlur={(e) => update("category", e.target.value)} onChange={(e) => setMarkProduct(e.target.value)} target={"name"} data={marks} />
                        <Select name={"Estoque do produto *"} editValue={typeStockProduct} onBlur={(e) => update("type_stock", e.target.value)} onChange={(e) => { setTypeStockProduct(e.target.value); setSelectTypeStock(e.target.value) }} target={"value"} data={typeStock} />
                    </CardInput>

                    {typeStockProduct == "Sob Encomenda"

                        ?
                        <CardInput>
                            <Input name={"Quantidade *"} mask="99999999999" onBlur={(e) => update("qtd_stock", e.target.value)} onChange={(e) => setQtdStock(e.target.value)} value={qtdStock} />

                        </CardInput>

                        :

                        typeStockProduct != undefined
                            ?
                            <CardInput>
                                <Input name={"Quantidade (Pronta Entrega) *"} onBlur={(e) => update("qtd_stock", e.target.value)} mask="99999999999" onChange={(e) => setQtdStock(e.target.value)} value={qtdStock} />

                            </CardInput>
                            :
                            <></>
                    }

                    <CardInput>
                        <Select name={"Categoria do produto *"} onBlur={(e) => update("engateCategory", e.target.value)} target={"name"} editValue={categoryProduct} onChange={(e) => setCategoryProduct(e.target.value)} data={categorys} />
                        <Select name={"Sub Categoria do produto *"} onBlur={(e) => update("sub_category", e.target.value)} target={"name"} editValue={subCategoryProduct} onChange={(e) => setSubCategoryProduct(e.target.value)} data={subCategorys} />
                    </CardInput>

                    <CardInput>
                        <Select name={"Sessão do produto *"} onBlur={(e) => update("session_product", e.target.value)} editValue={sessionProduct} onChange={(e) => setSessionProduct(e.target.value)} target={"name"} data={typeSession} />
                        <Select name={"Frete Grátis *"} onBlur={(e) => update("free_shipping", e.target.value)} editValue={freeShippingProduct} onChange={(e) => setFreeShippingProduct(e.target.value)} target={"name"} data={freeShipping} />
                    </CardInput>

                    <ContainerTextArea>
                        <CardTextArea>
                            <TextArea description={description} id={editProductData?.id} type={"update"} />
                        </CardTextArea>
                    </ContainerTextArea>


                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Códigos</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"SKU *"} onBlur={(e) => update("sku", e.target.value)} onChange={(e) => setSku(e.target.value)} value={sku} />
                        <Input name={"Código de barras *"} onBlur={(e) => update("barCode", e.target.value)} value={barCodeEdit} onChange={(e) => { setBarCodePreview(e.target.value); setBarCodeEdit(e.target.value) }} mask="999999999999999" />
                    </CardInput>

                    {barCodePreview

                        ?
                        <CardInput>
                            <CardBarCode>
                                <Barcode value={barCodePreview} fontSize={15} marginRight={0} marginLeft={0} />
                            </CardBarCode>
                            <div style={{ width: "100%" }}></div>

                        </CardInput>

                        :
                        <></>
                    }

                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Peso e dimensões</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"Peso (KG) *"} onBlur={(e) => update("weight", e.target.value)} value={weight} onChange={(e) => setWeight(e.target.value)} />
                        <Input name={"Comprimento *"} onBlur={(e) => update("length", e.target.value)} value={lenght} onChange={(e) => setLenght(e.target.value)} />
                    </CardInput>

                    <CardInput>
                        <Input name={"Largura *"} onBlur={(e) => update("width", e.target.value)} value={width} onChange={(e) => setWidth(e.target.value)} />
                        <Input name={"Altura *"} onBlur={(e) => update("height", e.target.value)} value={height} onChange={(e) => setHeight(e.target.value)} />
                    </CardInput>


                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Imagens</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"Imagem *"} accept=".png, .jpg, .jpeg" type={"File"} onChange={(e) => handleImage(e.target.files[0])} />
                    </CardInput>

                    <CardInput>

                        <CardImagesPreview>

                            {imagesPreview?.map((item, index) => {
                                return (
                                    <CardImage>
                                        <img src={deletIcon} onClick={() => handleRemoveImage(index, item.id)} className='delete_icon' />
                                        <ImagePreview src={`data:image/;base64;${item}`} />
                                    </CardImage>
                                )
                            })}

                            {productImages?.map((item, index) => {
                                return (
                                    <CardImage>
                                        <img src={deletIcon} onClick={() => handleRemoveImageDatabase(index, item.id)} className='delete_icon' />
                                        <ImagePreview src={`${item.image}`} />
                                    </CardImage>
                                )
                            })}

                        </CardImagesPreview>


                    </CardInput>

                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Informações de lucro</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    <CardInput>
                        <Input name={"Preço *"} onBlur={(e) => update("promotion_price", e.target.value)} value={promotionPrice} onChange={(e) => setPromotionalPrice(e.target.value)} />
                        <Input name={"Preço promocional *"} onBlur={(e) => update("price", e.target.value)} value={price} onChange={(e) => setPrice(e.target.value)} />
                    </CardInput>


                    <CardInput>
                        <div style={{ width: "100%" }}><p className='textPrimary'>Ficha Técnica</p></div>
                        <div style={{ width: "100%" }}></div>
                    </CardInput>

                    {dataSheet?.map((item, index) => {
                        var calcIndex = index
                        var totalIndex = calcIndex += 1
                        return (
                            <motion.div
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                            >
                                <ContainerCardDataSheet>
                                    <p>{totalIndex}</p>
                                    <img src={deletIcon} onClick={() => handleRemoveDataSheet(index)} className='delete_icon_datasheet' />

                                    <CardDataSheet>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                                            <InputDataSheet placeholder='Nome *' value={item.name} onBlur={() => update("datasheet", dataSheet, "edit")} onChange={(e) => handleUpdateDataSheet(index, "name", e.target.value)} />
                                            <InputDataSheet placeholder='Valor *' value={item.value} onBlur={() => update("datasheet", dataSheet, "edit")} onChange={(e) => handleUpdateDataSheet(index, "value", e.target.value)} />
                                        </div>
                                    </CardDataSheet>
                                </ContainerCardDataSheet>
                            </motion.div>
                        )
                    })}


                    <CardInput>
                        <div onClick={() => handleNewDataSheet()}>
                            <Lottie options={defaultOptions}
                                isClickToPauseDisabled
                                isPaused={false}
                                height={90}
                                width={90}
                            />
                        </div>
                    </CardInput>

                </CardWrapper>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => handleUpdate()}>{btnAnimation == true ? <ReactLoading type={"bars"} color={"white"} height={25} width={25} /> : "Editar"}</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalEditProduct